function isObject(data) {
    return typeof data === "object" && data !== null;
}

const coupon = {
    get() {
        try {
            const coupon = JSON.parse(localStorage.getItem("coupon"));

            if (!isObject(coupon)) {
                return {
                    status: false,
                    balance_amount: 0,
                    total_amount: 0,
                    balance_value: 0,
                    total_value: 0
                }
            }

            return {
                status: true,
                balance_amount: coupon.balance_amount,
                total_amount: coupon.total_amount,
                balance_value: coupon.balance_value,
                total_value: coupon.total_value
            }
        } catch (err) {
            return {
                status: false,
                balance_amount: 0,
                total_amount: 0,
                balance_value: 0,
                total_value: 0
            }
        }
    }
}

export default coupon